export default "__VITE_ASSET__B7Yi9qoI__"